import { Component } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import Icon from 'src/view/components/Controls/Icon/Icon';
import './style.scss';

interface IProps {
  iconName: Icons;
  iconClassName?: string;
  size?: number;
}

export default class MapMarker extends Component<IProps, {}> {
  render() {
    return (
      <div onClick={() => console.info('CLICKED')} className="map-marker__wrapper">
        <div className="map-marker">
          <Icon
            className={`map-marker__icon color-mainblue ${this.props.iconClassName || ''}`}
            name={this.props.iconName}
            size={this.props.size || 40}
          />
        </div>
      </div>
    );
  }
}
